module.exports = __webpack_public_path__ + "static/media/S9.75455126.webp";